import styled from "styled-components";
import { theme } from "../../../helpers/theme"

export const ViewBody = styled.div`
background-color: ${theme.colors.gray04_background};
display: flex;
flex-direction: col;
justify-content: center;
flex-direction: column;
align-items: center;
padding:50px;
`;
export const FormWrapper = styled.div`
display: flex;
flex-direction: column;
gap: 24px;
padding:20px 0px;
min-width:260px;
text-align: center;
`;
export const FormHeading = styled.h4`
font-family: ${theme.fonts.interBold};
font-style: normal;
font-weight:  ${theme.fontWeight.big};
font-size: 24px;
line-height: 32px;
color: ${theme.colors.black_primaryText};
margin:0px;
`;
export const Description = styled.p`
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: ${theme.fontWeight.small};
font-size: 14px;
line-height: 20px;
color: ${theme.colors.black_primaryText};
margin-top:0px;
`;

export const ImgSVG = styled.img`
    min-height: 3rem;
    margin-top:20px;
    min-width:150px;
    max-width:25%;
`;

